import { create } from 'zustand';

/**
 * Lets a page hold the onboarding checklist back, so the two never share the corner. The checklist
 * mounts from ProtectedPage and the holders from their own pages, so a module-level store is what
 * they have in common.
 *
 * The build details page holds it twice: the AI signpost (CI-6462), which releases a second after its
 * own dismissal, and a failed build (CI-6521). Both can be on screen at once, so it takes every holder
 * letting go to reopen it.
 */
type OnboardingChecklistGate = {
  holders: string[];
  hold: (holder: string) => void;
  release: (holder: string) => void;
};

const useOnboardingChecklistGate = create<OnboardingChecklistGate>((set) => ({
  holders: [],
  hold: (holder) => set((state) => ({ holders: [...state.holders, holder] })),
  release: (holder) => set((state) => ({ holders: state.holders.filter((h) => h !== holder) })),
}));

export const useIsOnboardingChecklistHeld = () => useOnboardingChecklistGate((state) => state.holders.length > 0);

export const holdOnboardingChecklist = (holder: string) => useOnboardingChecklistGate.getState().hold(holder);

export const releaseOnboardingChecklist = (holder: string) => useOnboardingChecklistGate.getState().release(holder);

export default useOnboardingChecklistGate;
